import React, { useState, useRef } from 'react';
import { useCalendar } from './CalenderContext';
import { AddEventModal, UpdateEventModal, AllEventMiniModal, AllEventDetailModal } from './AddEventModal';

const MonthView = () => {
  const {
    currentMonth,
    handleDayClick,
    selectedDate,
    daysOfWeek,
    todayDate,
    todayMonth,
    todayYear,
    handleClickOnEventName,
    withStopPropagation,
    showModal,
    setShowModal,
    showModalupdate,
    setShowModalupdate,
    selectedTimeSlot,
    timeSlots,
    isShowAllEventDatemini,
    setShowAllEventDatemini,
    handleShowAllEvent,
    selectedEventmini,
    handleShowAllEventDetail,
    setShowModaldetail,
    showModaldetail,
    handleShowAllUpdate,
    selectedEventDetail,
    selectedEventupdate,
    setselectedTimeSlot,
    SetSelectedEventDetail,
    view,
    meetingData,
    getMeetingData,
    Handlecloseallmodal,
  } = useCalendar();

  const [dayPosition, setDayPosition] = useState(null);
  const [clickFromEvent, setClickFromEvent] = useState(false);
  console.log(selectedEventDetail)
  // Add a reference to track if a click came from an event
  const eventClickRef = useRef(false);


  // Modified day click handler that checks if the click originated from an event
  const handleDayClickWithPosition = (day, idx, event) => {
    // Skip if day is empty
    if (!day) return;

    // Check if this click originated from an event
    if (eventClickRef.current) {
      // Reset the flag for next click
      eventClickRef.current = false;
      return; // Exit without processing the day click
    }

    // Get current time
    const now = new Date();
    const currentHour = now.getHours();

    // Round to the nearest hour (or use current hour)
    const hour = currentHour;

    // Set the start time at the current hour
    const startTime = `${String(hour).padStart(2, "0")}`;

    // Set the end time one hour later
    const endHour = (hour + 1) % 24; // Handle 24-hour wrap around
    const endTime = `${String(endHour).padStart(2, "0")}`;

    // Get AM/PM format for display purposes
    const startPeriod = hour < 12 ? 'AM' : 'PM';
    const endPeriod = endHour < 12 ? 'AM' : 'PM';
    const startHour12 = hour % 12 || 12; // Convert to 12-hour format
    const endHour12 = endHour % 12 || 12; // Convert to 12-hour format

    // Format the date from the day
    const selectedDateStr = day.toISOString().split('T')[0]; // YYYY-MM-DD format

    // Create a combined selected time slot object
    const timeSlotData = {

      start: `${startHour12}`,
      end: `${endHour12}`,

    };
    console.log(timeSlotData)
    // Set the selected time slot
    setselectedTimeSlot(timeSlotData);

    // Get the position for the modal
    const rect = event.currentTarget.getBoundingClientRect();
    const position = {
      x: rect.left,
      y: rect.top
    };

    setDayPosition(position);
    handleDayClick(day, idx);
    setShowModal(true);
  };

  // New completely isolated event click handler
  const handleEventClick = (e, events, day) => {
    // Set the flag to indicate this click originated from an event
    eventClickRef.current = true;

    // Call stopPropagation as a first line of defense
    e.stopPropagation();
    e.preventDefault();

    // Process the event click
    handleShowAllEventDetail(e, events, day);
  };

  // New isolated "more" button click handler
  const handleMoreClick = (e, events, day) => {
    // Set the flag to indicate this click originated from an event
    eventClickRef.current = true;

    // Call stopPropagation as a first line of defense
    e.stopPropagation();
    e.preventDefault();

    // Process the "more" click
    handleShowAllEvent(e, events, day);
  };
  const [selectedDay, setSelectedDay] = useState(null);
  const renderEvents = (day, monthIndex, eventGroupByDate) => {
    const maxEventsToShow = 1;
    const events = eventGroupByDate || [];
    const more = events.length - maxEventsToShow;
    const sortedMeetingData = [...events].sort((a, b) => {
      const timeToMinutes = (time) => {
        if (!time) return Infinity; // Handle missing times
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
      };

      const startTimeA = timeToMinutes(a.start_time);
      const startTimeB = timeToMinutes(b.start_time);

      return startTimeA - startTimeB;
    });

    return (
      <>
        {sortedMeetingData.slice(0, maxEventsToShow).map((evt, index) => (
          <div
            key={index}
            className="event-container"
            onClick={(e) => {
              // This extra internal div helps prevent propagation
              e.stopPropagation();
              e.preventDefault();
              setSelectedDay(index);
            }}
          >
            <div
              className="event-name"
              onClick={(e) => handleEventClick(e, events, day)}
              onMouseDown={(e) => {
                // Set flag on mousedown too
                eventClickRef.current = true;
                e.stopPropagation();
              }}
            //   style={{
            //       backgroundColor: '#4285f4',
            //       color: 'white',
            //       padding: '2px 5px',
            //       margin: '1px 0',
            //       borderRadius: '2px',
            //       fontSize: '12px',
            //       whiteSpace: 'nowrap',
            //       overflow: 'hidden',
            //       textOverflow: 'ellipsis',
            //       cursor: 'pointer',
            //       pointerEvents: 'all' // Ensure this element gets click events
            //   }}
            >
              {`${evt.title}${evt.start_time}`}
              <AllEventDetailModal
                setShowModaldetail={setShowModaldetail}
                showModal={showModaldetail}
                onClose={() => {
                  // This extra internal div helps prevent propagation
                  setShowModaldetail(false);
                  // SetSelectedEventDetail([])
                }}

                selectedEvent={[evt]}
                dayPosition={dayPosition}
                showModalupdate={showModalupdate}
                setShowModalupdate={setShowModalupdate}
                handleShowAllUpdate={handleShowAllUpdate}
                timeSlots={timeSlots}
                selectedTimeslot={selectedTimeSlot}
                selectedEventupdate={selectedEventupdate}
                selectedDate={selectedDate}

              />
            </div>
          </div>
        ))}

        {more > 0 && (
          <div
            className="more-container"
            onClick={(e) => {
              // Internal div to help prevent propagation
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <div
              onClick={(e) => handleMoreClick(e, events, day)}
              onMouseDown={(e) => {
                // Set flag on mousedown too
                eventClickRef.current = true;
                e.stopPropagation();
              }}
              className="event-name see-more-btn w-max"
              style={{
                cursor: 'pointer',
                pointerEvents: 'all' // Ensure this element gets click events
              }}
            >
              {more} more...
            </div>
            <AllEventMiniModal
              showModal={isShowAllEventDatemini}
              onClose={() => {
                setShowAllEventDatemini(false);
                setShowModal(false);
              }}
              dayPosition={dayPosition}
              selectedEventmini={selectedEventmini}
              showModaldetail={showModaldetail}
              timeSlots={timeSlots}
              selectedTimeslot={selectedTimeSlot}
              setShowModaldetail={setShowModaldetail}
              handleShowAllEventDetail={handleShowAllEventDetail}
              handleShowAllUpdate={handleShowAllUpdate}
              selectedDate={selectedDate}
            />
          </div>
        )}
      </>
    );
  };

  return (
    <div className="calendar-grid">
      {daysOfWeek?.map((dayName, idx) => (
        <div key={idx} className="day-name">
          {dayName}
        </div>
      ))}

      {currentMonth.map((row, i) => (
        <React.Fragment key={i}>
          {row.map((day, idx) => {
            const dayEvents = day && meetingData.length > 0 ? meetingData.filter((event) => {
              const eventDate = new Date(event.meeting_date);
              return (
                eventDate.getDate() === day.getDate() &&
                eventDate.getMonth() === day.getMonth() &&
                eventDate.getFullYear() === day.getFullYear()
              );
            }) : [];

            const isToday = day && day.getDate() === todayDate && day.getMonth() === todayMonth && day.getFullYear() === todayYear;
            const isSelected = day && selectedDate && day.getDate() === selectedDate.getDate() && day.getMonth() === selectedDate.getMonth() && day.getFullYear() === selectedDate.getFullYear();
            const hasEvent = dayEvents.length > 0;

            return (
              <button
                key={idx}
                className="day-button"
                onClick={(event) => handleDayClickWithPosition(day, idx, event)}
              >
                <span className='day-number' ><span className={` ${isSelected ? "selected" : ""} ${isToday ? "today" : ""} `}>{day ? day.getDate() : ""}</span></span>
                {hasEvent && renderEvents(day, i, dayEvents)}
              </button>
            );
          })}
        </React.Fragment>
      ))}

      {console.log(selectedEventupdate, 'selectimeslot')}
      {showModal && view === "month" && <AddEventModal
        showModal={showModal}
        onClose={() => setShowModal(false)}
        dayPosition={dayPosition}
        timeSlots={timeSlots}
        selectedTimeslot={selectedTimeSlot}
        selectedDate={selectedDate}
        getMeetingData={getMeetingData}
        Handlecloseallmodal={Handlecloseallmodal}
      />}
      {showModalupdate && view === "month" &&
        <UpdateEventModal
          showModal={showModalupdate}
          onClose={() => setShowModalupdate(false)}
          dayPosition={dayPosition}
          timeSlots={timeSlots}
          selectedTimeslot={selectedTimeSlot}
          selectedEvent={selectedEventupdate}
          setShowModalupdate={setShowModalupdate}
          getMeetingData={getMeetingData}
          Handlecloseallmodal={Handlecloseallmodal}

        />}
    </div>
  );
};

export default MonthView;